<div class="element">
  <div class="element__number">{{number}}</div>

  <div class="element__name">{{name}}</div>

  <div class="element__percentage">{{percentageValue + ' %'}}</div>
</div>
